import React, { useEffect, useState } from 'react';
import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react';
import { GiTwoCoins } from 'react-icons/gi';

const OPERATION_LABELS = {
  custom_field: 'Custom field generation',
  custom_field_backfill: 'Custom field backfill',
  email_draft: 'Message draft generation',
};

/**
 * Inline credit spend confirmation in the chat panel (agent-initiated full runs).
 * Countdown is informational; the server auto-accepts after timeout_sec.
 */
const CreditSpendGateCard = ({ gate, onDecision }) => {
  const [secondsLeft, setSecondsLeft] = useState(gate?.timeout_sec ?? 20);

  useEffect(() => {
    if (!gate?.gate_id) return undefined;
    const tmax = gate.timeout_sec ?? 20;
    setSecondsLeft(tmax);
    const id = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, [gate?.gate_id, gate?.timeout_sec]);

  if (!gate?.gate_id || gate?.kind !== 'prompt') return null;

  const label = OPERATION_LABELS[gate.operation_type] || 'Continue generation';
  const need = gate.credits_needed ?? 0;
  const bal = gate.balance ?? '—';

  return (
    <Box
      bg="rgba(18, 18, 18, 0.97)"
      borderWidth="1px"
      borderColor="rgba(255,255,255,0.12)"
      borderRadius="md"
      px={3}
      py={2.5}
      boxShadow="0 4px 24px rgba(0,0,0,0.45)"
    >
      <VStack align="stretch" spacing={2}>
        <HStack spacing={2} align="center">
          <Box
            as={GiTwoCoins}
            color="#facc15"
            boxSize="16px"
            flexShrink={0}
            aria-hidden
          />
          <Text fontSize="sm" fontWeight="600" color="rgba(250,250,250,0.92)">
            {label}
          </Text>
        </HStack>
        <Text fontSize="xs" color="rgba(255,255,255,0.55)" lineHeight="1.45">
          Preview is done. Full generation will use about <strong>{need}</strong> credits
          (balance {bal}).
          {gate.preview_allows_overage_proceed
            ? ' Overage may apply per your billing settings.'
            : ''}
        </Text>
        <Text fontSize="xs" color="rgba(255,255,255,0.35)">
          Continues automatically in {secondsLeft}s if you do not choose.
        </Text>
        <HStack spacing={2} justify="flex-end" pt={1}>
          <Button
            size="xs"
            variant="ghost"
            color="rgba(255,255,255,0.5)"
            _hover={{ color: 'rgba(255,255,255,0.85)', bg: 'rgba(255,255,255,0.06)' }}
            onClick={() => onDecision?.('reject')}
          >
            Decline
          </Button>
          <Button
            size="xs"
            bg="rgba(250,250,250,0.92)"
            color="#0a0a0a"
            _hover={{ bg: 'white' }}
            onClick={() => onDecision?.('accept')}
          >
            Continue now
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default CreditSpendGateCard;
